export class WarehouseDto {
	warehouseId: number;
	name: string;
	description: string;
	fullAddress: string;
	serviceCenterIds: number[] = [];
}
